import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { NumberFormatter } from '../utils/NumberFormatter'
import Context from '../context/Context'
import PropTypes from 'prop-types'

const Amount = ({ text, amount }) => {
  return (
    <span className="thousandSeparator">
      {text}&nbsp;{NumberFormatter.round(Math.abs(amount))}
    </span>
  )
}

const LinkElement = ({ totalAmount, remainingAmount, style, url }) => {
  if (totalAmount < '0') {
    return (
      <Link
        style={style.button}
        to={'payment/' + url}
        className="btn btn-primary custom-btn disabled">
        {<Amount text={'Tillgodo'} amount={totalAmount} />}:-
      </Link>
    )
  } else if (remainingAmount === '0') {
    return (
      <Link
        style={style.button}
        to={'payment/' + url}
        className="btn btn-primary custom-btn disabled">
        {<Amount text={'Belopp'} amount={remainingAmount} />}:-
      </Link>
    )
  } else if (remainingAmount > '0') {
    return (
      <Link
        style={style.button}
        to={'payment/' + url}
        className="btn btn-primary custom-btn">
        {<Amount text={'Betala'} amount={remainingAmount} />}:-
      </Link>
    )
  }
}

const PaymentButton = () => {
  const context = useContext(Context)

  return (
    <div className="row">
      <div className="col-12 text-center">
        {<LinkElement
          totalAmount={context.invoice.total_amount}
          remainingAmount={context.invoice.remaining_amount}
          style={context.style}
          url={context.url} />
        }
      </div>
    </div>
  )
}

Amount.propTypes = {
  text: PropTypes.string,
  amount: PropTypes.string
}

LinkElement.propTypes = {
  totalAmount: PropTypes.string,
  remainingAmount: PropTypes.string,
  style: PropTypes.object,
  url: PropTypes.string
}

export default PaymentButton
